import React, { useEffect, useMemo, useState } from 'react'
import Loading from '../../Loading'
import { useTranslation } from 'react-i18next'
import { counsellorData } from '../../../constants/CounsellorAnalyticsConstants'
import InfoButton from '../../common/InfoButton'
import CounsellorProgressBar from './CounsellorProgressBar'
import { getCounsellorAnalyticsInfo } from '../../../server/server'

function CounsellorCardData({ selectedOptions }) {
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState(counsellorData)

    useEffect(() => {
        setLoading(true)
        loadData(selectedOptions)
    }, [])

    const loadData = async (data) => {
        const resp = await getCounsellorAnalyticsInfo(data)
        if (resp.status === 200) {
            setData(resp.data)
        } else {
            setData(null)
        }
        setLoading(false)
    }

    return (
        <div>
            {loading && <LoadingContainer data={data} />}
            {!loading && !data && <LoadingContainer showEmptyData={true} />}
            {!loading && !!data && <CounsellorCardSummary data={data} />}
        </div>
    )
}

export default CounsellorCardData

export const CounsellorCardSummary = ({ data, title, breakdownLabel }) => {
    const { t } = useTranslation()
    const institutionName = useMemo(() => {
        return data?.institution?.name
    }, [data?.institution])

    return (
        <div className={`p-8 rounded-[24px] relative bg-[#D3D5FF]`} data-tour="basic-info">
            <div className="flex flex-row justify-end">
                <InfoButton color="#77768D" text={t('Overall balance of emotions logged since the start of the school year.')} />
            </div>
            <p className="text-darkenPurple text-[31px] leading-[36px] font-semibold tracking-tight">{title ?? institutionName}</p>
            <div className="w-full h-[1px] bg-white mt-4"></div>
            <div className="bg-[#FFFFFF66]  flex flex-col p-5 rounded-[16px] mt-8 ">
                <p className="text-darkenPurple text-[16px] leading-[24px] font-semibold mb-2">
                    {breakdownLabel ?? t(data?.coverageScoped ? 'Assigned groups emotional breakdown based on {{number}} check-ins' : 'School-wide emotional breakdown based on number check-ins', { number: data?.emotionsData?.numberOfEmotions })}
                </p>
                <div className="mb-[8px]">
                    <p className="font-medium text-[#77768D] text-[12px] ">{t('This data shows the ratio of logged emotions from the start of the school year until today')}</p>
                </div>
                <CounsellorProgressBar comfortableEmotions={data?.emotionsData?.comfortableEmotions ?? 0} uncomfortableEmotions={data?.emotionsData?.uncomfortableEmotions ?? 0} />
                <div className="flex flex-row gap-8 mt-2">
                    <div className="flex flex-row items-center gap-2 ">
                        <div className="w-[11px] h-[11px] border border-[#2B793F] bg-[#6FCC8799] rounded-[2px]"> </div>
                        <p className="text-[12px] leading-[16px] font-medium text-[#77768D] ">{t('Comfortable')}</p>
                    </div>
                    <div className="flex flex-row items-center gap-2 ">
                        <div className="w-[11px] h-[11px] border border-[#78020B] bg-[#FC4C5999] rounded-[2px]"> </div>
                        <p className="text-[12px] leading-[16px] font-medium text-[#77768D] ">{t('Uncomfortable')}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

const LoadingContainer = ({ showEmptyData = false, data = counsellorData }) => {
    const { t } = useTranslation()

    return (
        <div className="relative">
            <div className="blur">
                <CounsellorCardSummary data={data} />
            </div>
            {showEmptyData ? (
                <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
                    <div className="flex flex-col items-center">
                        <p className="text-[16px] leading-[25px] font-bold text-mudPurple ">{t('No data found')}</p>
                        <p className="text-[14px] leading-[25px] font-medium text-mudPurple px-5 text-center">
                            {t('This element will be updated once enough app-activity has been recorded')}
                        </p>
                    </div>
                </div>
            ) : (
                <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
                    <Loading size={50} stroke={5} primaryColor="#7C82C3" secondaryColor="white" />
                </div>
            )}
        </div>
    )
}
